var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('h1',[_vm._v("Links")]),_c('ul',_vm._l((_vm.company_names),function(company){return _c('li',{key:company.name},[_vm._v(_vm._s(company.name))])}),0)])])])}
var staticRenderFns = []

export { render, staticRenderFns }